
import AlignHorizontally from "../../../assets/outline/AlignHorizontally.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AlignHorizontallyIcon({ className, dataTestid = "AlignHorizontallyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AlignHorizontally data-testid={dataTestid} className={classes} {...rest} />
  );
}
